import { Component, createSignal } from 'solid-js'
import FormModal from '/web/shared/FormModal'
import { userStore } from '/web/store'
import { formStore } from '/web/store/form'
import Button from '/web/shared/Button'

const CharacterFormModal: Component = () => {
  const state = userStore()
  const [loading, setLoading] = createSignal(false)

  const handleSubmit = async (e: Event) => {
    e.preventDefault()
    const form = e.target as HTMLFormElement
    const data = {
      characterName: form.characterName.value,
      email: form.email.value,
    }

    setLoading(true)
    const success = await formStore.submitCharacterForm(data)
    setLoading(false)

    if (success) {
      userStore.characterModal(false)
    }
  }

  return (
    <FormModal
      title="Submit Your Character"
      isOpen={state.showCharacter}
      onClose={() => userStore.characterModal(false)}
      onSubmit={handleSubmit}
    >
      <div class="flex flex-col gap-6">
        <div class="flex flex-col">
          <div class="mb-5 text-[16px]">
            Is your cosplay character not listed? Send us the name and we’ll make it happen!
          </div>
          <label class="mb-2 block font-clash text-[15px] text-white">
            Character Name <span class="text-xs font-normal text-cosplay-blue-100">(Required)</span>
          </label>
          <input
            name="characterName"
            required
            placeholder="Enter character name"
            class="rounded-xl border border-white bg-white/10 p-4 text-sm"
          />
        </div>
        <div class="flex flex-col">
          <label class="mb-2 block font-clash text-[15px] text-white">
            Email Address <span class="text-xs font-normal text-cosplay-blue-100">(Required)</span>
          </label>
          <input
            name="email"
            type="email"
            required
            placeholder="Enter your email"
            class="rounded-xl border border-white bg-white/10 p-4 text-sm"
          />
        </div>
        <button
          class="mb-6 mt-3 rounded-lg border-[0.5px] border-white bg-gradient-to-r from-cosplay-blue-200 to-cosplay-purple px-4 py-2 text-[22px] font-bold"
          type="submit"
          disabled={loading()}
        >
          {loading() ? 'Submitting...' : 'Submit'}
        </button>
      </div>
    </FormModal>
  )
}

export default CharacterFormModal
